import { Icon } from 'antd';
import React from 'react';

const optionsDefault = {
  okText: 'Всё готово!',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};

export const successAddProfile = () => ({
  ...optionsDefault,
  content: `Вы успешно зарегистрированы в сервисе Teleportos!
Сейчас вы будете перенаправлены на главную страницу, где сможете начать работу!
Спасибо, что выбрали нас!`,
});
